import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {GlobalUtils} from "../../utils/global-utils";
import {MenuUtil} from "../../utils/menu-utils";


@Component({
  selector: 'app-faq-shortcut',
  templateUrl: './faq-shortcut.component.html',
  styleUrls: ['./faq-shortcut.component.scss']
})
export class FaqShortcutComponent implements OnInit {


  constructor(private router : Router) { }
  
  get showFAQShortcut(): boolean {
    let routerData = JSON.parse(GlobalUtils.getStorageItem("router"));
    return routerData.some(item => item.url === 'faq');
  };

  goFaq() {
    this.router.navigateByUrl('faq')
  }

  ngOnInit() {
  }

}
